import type { StaffingWorker } from './model';

export const fixtureStaffingWorkers: StaffingWorker[] = [
  {
    id: '01', personId: 'person-01', workerNumber: 'A0001', name: '정성진', initials: '정',
    organizationId: 'root', organization: '한결', title: '대표이사', businessTitle: '대표이사', jobLevel: 'L7', jobType: '정규직', jobTypeId: 'job-type-regular',
    timeType: 'FULL_TIME', location: '서울 본사', locationId: 'location-seoul', workSpace: '4층 Executive Zone',
    workSpaceId: 'work-space-seoul-executive', status: '재직', workerTypeId: 'EMPLOYEE',
  },
  {
    id: '02', personId: 'person-02', workerNumber: 'A0104', name: '우디(박진우)', initials: '우디',
    organizationId: 'engineering', organization: 'Engineering Division', title: 'Engineering Director', businessTitle: 'Engineering Director', jobLevel: 'L6', jobType: '정규직',
    jobTypeId: 'job-type-regular', timeType: 'FULL_TIME', location: '서울 본사', locationId: 'location-seoul',
    workSpace: '4층 Engineering Zone', workSpaceId: 'work-space-seoul-4f', status: '재직', workerTypeId: 'EMPLOYEE',
  },
  {
    id: '03', personId: 'person-03', workerNumber: 'A0142', name: '김민서', initials: '김',
    organizationId: 'product', organization: 'Product Division', title: 'Product Manager', businessTitle: 'Product Manager', jobProfile: 'Product Manager', jobLevel: 'L4', jobType: '정규직',
    jobTypeId: 'job-type-regular', timeType: 'FULL_TIME', location: '서울 본사', locationId: 'location-seoul',
    workSpace: '5층 Product Zone', workSpaceId: 'work-space-seoul-5f', status: '재직', workerTypeId: 'EMPLOYEE',
  },
  {
    id: '04', personId: 'person-04', workerNumber: 'A0188', name: '이수연', initials: '이',
    organizationId: 'design', organization: 'Design Team', title: 'Product Designer', businessTitle: 'Product Designer', jobLevel: 'L3', timeType: 'FULL_TIME',
    location: '서울 본사', status: '휴직',
  },
  {
    id: '05', personId: 'person-05', workerNumber: 'A0203', name: '한도윤', initials: '한',
    organizationId: 'business', organization: 'Business Division', title: 'Growth Manager', businessTitle: 'Growth Manager', jobLevel: 'L4', timeType: 'FULL_TIME',
    location: '제주 지점', status: '재직',
  },
  {
    id: '06', personId: 'person-06', workerNumber: 'A0221', name: '강예린', initials: '강',
    organizationId: 'people', organization: 'People & Culture', title: 'HR Operations Manager', businessTitle: 'HR Operations Manager', jobLevel: 'L4', timeType: 'FULL_TIME',
    location: '서울 본사', status: '재직',
  },
  {
    id: '07', personId: 'person-07', workerNumber: 'A0238', name: '장우진', initials: '장',
    organizationId: 'platform', organization: 'Platform Engineering Team', title: 'Backend Engineer', businessTitle: 'Backend Engineer', jobLevel: 'L3', timeType: 'FULL_TIME',
    location: '경북 지점', status: '퇴직 예정',
  },
];
